import { Button } from '@repo/shadcn';
import { CornerDownLeft, Printer } from 'lucide-react';
import { Link } from 'react-router-dom';

import { HeaderBreadcrumb } from '@components/ui';
import { PaymentStatusBadge } from '@components/ui/badge';

import { Route } from '@/constants';
import { usePurchaseDetailsContext } from '@/modules/purchase/purchase-details/purchase-details.context';

export const PurchaseHeader = () => {
    const { data, isLoading, printInvoice } = usePurchaseDetailsContext();

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (!data) {
        return <div>No Data Available</div>;
    }

    return (
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-start">
            <div>
                <HeaderBreadcrumb
                    showHomeLink={true}
                    items={[
                        { label: 'Purchases', href: Route.PURCHASES },
                        {
                            label:
                                data?.data?.invoice_number ??
                                'Purchase Details',
                        },
                    ]}
                />
                <h1 className="flex items-center gap-3 text-xl font-bold text-foreground">
                    <span>
                        Invoice No: {data?.data?.invoice_number ?? '---'}
                    </span>
                    <PaymentStatusBadge status={data?.data?.payment?.status} />
                </h1>
                <p className="text-sm">
                    Date:{' '}
                    {new Date(
                        data?.data?.created_at ?? Date.now(),
                    ).toLocaleDateString()}
                </p>
                <p className="text-sm">
                    Served By:{' '}
                    {data?.data?.user?.name ? (
                        <Link to={`/users/${data.data.user.id}`}>
                            <Button variant="link" className="m-0 p-0">
                                {data.data.user.name}
                            </Button>
                        </Link>
                    ) : (
                        '---'
                    )}
                </p>
            </div>
            <div className="flex gap-3">
                <Button
                    className="gap-2 bg-transparent"
                    variant={'outline'}
                    // onClick={() => {}}
                >
                    <Link
                        className="flex items-center justify-center gap-2"
                        to={`${Route.PURCHASE_RETURN_CREATE}?purchase_id=${data?.data?.id}`}
                    >
                        <CornerDownLeft />
                        Return
                    </Link>
                </Button>

                <Button
                    className="gap-2 bg-transparent"
                    variant={'outline'}
                    onClick={printInvoice}
                >
                    <Printer className="h-4 w-4" />
                    Print Invoice
                </Button>
            </div>
        </div>
    );
};

PurchaseHeader.displayName = 'PurchaseHeader';
